// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductBadgeEcoFriendly: React.FC<{
    size?: number;
    color1?: string;
    color2?: string;
    color3?: string;
    className?: string;
}> = ({ size = 18, color1 = "#fff", color2 = "#ccc", color3 = "#71984a", className }) => (
    <svg className={className} focusable="false" viewBox="0 0 18 18" width={size} height={size}>
        <g fill="none" fillRule="evenodd">
            <rect width="18" height="18" fill={color1} rx="9" />
            <path
                fill={color2}
                fillRule="nonzero"
                d="M9 0a9 9 0 1 1 0 18A9 9 0 0 1 9 0m0 .5a8.5 8.5 0 1 0 0 17 8.5 8.5 0 0 0 0-17"
            />
            <path
                fill={color3}
                fillRule="nonzero"
                d="M6.922 8.566a4.1 4.1 0 0 1 1.297-.209H9.78c.26 0 .469.215.469.483a.474.474 0 0 1-.469.482H8.22a3.2 3.2 0 0 0-1.387.315c.15 1.271 1.203 2.256 2.479 2.256h.019c1.9-.01 3.733-2.015 3.733-4.89a6 6 0 0 0-.045-.753 3.03 3.03 0 0 1-1.674.5H9.313c-1.126 0-2.077.766-2.391 1.816m-1.04.517c.12-1.84 1.61-3.297 3.43-3.297h2.032c.56 0 1.07-.216 1.457-.572l.04-.038a2.2 2.2 0 0 0 .43-.577c.069-.13.266-.136.317.002a7 7 0 0 1 .225.76q.014.058.025.112c.105.488.162 1 .162 1.53 0 3.224-2.088 5.84-4.668 5.854h-.02c-1.595 0-2.937-1.12-3.324-2.636a3.4 3.4 0 0 0-1.05 2.475v.321a.474.474 0 0 1-.47.482.474.474 0 0 1-.468-.482v-.321c0-1.508.748-2.836 1.883-3.613"
            />
        </g>
    </svg>
);

export default React.memo(ProductBadgeEcoFriendly);
